/**
 * CPA Template Configuration
 *
 * routeExtensions contract:
 *   componentOverrides: { [routeKey]: Component } — replace a base route component
 *   additions:          [{ key, path, component }] — add routes not in base tree
 *   exclusions:         [routeKey]                 — remove routes from base tree
 *
 * navigation: sidebar tree — see ./navigation.js
 * assets:     cap image + locale selector — see ./assets.js
 */
import { sidebar } from './navigation';
import { cap, locales, brand, chart, icons, navIcons } from './assets';
import * as promoCodeStrategy from './promoCodeStrategy';
import './styles/main.less';
export default {
    name: 'cpa',
    features: {
        promoCode: promoCodeStrategy,
    },
    componentOverrides: {},

    routeExtensions: {
        componentOverrides: {},
        additions: [],
        exclusions: [],
    },
    navigation: {
        sidebar,
    },
    assets: {
        cap,
        locales,
        brand,
        chart,
        icons,
        navIcons,
    },
    // Shell override slots for divergent templates.
    // cpa uses the core baseline SideBar — no override needed.
    shellOverrides: {},
};
